// ======================================================================
// File Name       : participant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import * as ParticipantActionTypes from '../constants/actionTypes/participant';
import { createArrayDurationForChart, mapUserSecernIdWithGroupName } from '../utils/UserUtils';

const initialState = {};

export default function participant(state = initialState, action) {
  switch (action.type) {
    case ParticipantActionTypes.STORE_PARTICIPANT_LIST: {
      const { userSearchResult, groupRelationList, groupInfo, eachUserLiveCountList } = action;
      let newUserList = [];
      let userListDialogRecordNum = 0;
      let eachUserLiveCount = {};
      if (eachUserLiveCountList && eachUserLiveCountList.length) {
        eachUserLiveCount = eachUserLiveCountList.reduce((acc, cur) => {
          if (cur && cur.participantUserSecernId) {
            acc[cur.participantUserSecernId] = cur;
          }
          return acc;
        }, {});
      }
      if (userSearchResult && userSearchResult.userList && userSearchResult.userList.length) {
        const { userList } = userSearchResult;
        newUserList = userList.reduce((acc, cur) => {
          if (cur.userSecernId) {
            cur.groupNames = mapUserSecernIdWithGroupName(
              cur.userSecernId,
              groupRelationList,
              groupInfo,
            );
            if (eachUserLiveCount && eachUserLiveCount[cur.userSecernId] && eachUserLiveCount[cur.userSecernId].liveCount) {
              cur.liveCount = eachUserLiveCount[cur.userSecernId].liveCount;
            }
            if (eachUserLiveCount && eachUserLiveCount[cur.userSecernId] && eachUserLiveCount[cur.userSecernId].attendedLiveCount) {
              cur.attendedLiveCount = eachUserLiveCount[cur.userSecernId].attendedLiveCount;
            }
            acc.push(cur);
          }
          return acc;
        }, []);
        userListDialogRecordNum = userSearchResult.recordNum || 0;
      }
      return {
        ...state,
        userList: newUserList,
        userListDialogRecordNum,
      };
    }
    case ParticipantActionTypes.STORE_PARTICIPANT_DETAIL: {
      const { userSearchResult, groupRelationList, groupInfo } = action;
      let newUserList = [];
      if (userSearchResult && userSearchResult.userList && userSearchResult.userList.length) {
        const { userList } = userSearchResult;
        newUserList = userList.reduce((acc, cur) => {
          if (cur.userSecernId) {
            cur.groupNames = mapUserSecernIdWithGroupName(
              cur.userSecernId,
              groupRelationList,
              groupInfo,
            );
            acc.push(cur);
          }
          return acc;
        }, []);
      }
      return {
        ...state,
        userList: newUserList,
      };
    }
    case ParticipantActionTypes.STORE_PARTICIPANT_DETAIL_STATUS : {
      const { liverSearchResult, liveList, liveStatusInfo, userSearchRes } = action;
      let newLiveList = [];
      let liveRecordNum = 0;
      let liveReservedList = {};
      let liveUserObj = {};
      let userOrList = {};
      if (liveList && liveList.length) {
        liveReservedList = liveList.reduce((acc, cur) => {
          if (cur && cur.liveSecernId) {
            acc[cur.liveSecernId] = cur;
          }
          return acc;
        }, {});
      }
      if (userSearchRes && userSearchRes.userList && userSearchRes.userList.length) {
        userOrList = userSearchRes.userList.reduce((acc, cur) => {
          if (cur && cur.userSecernId) {
            acc[cur.userSecernId] = cur;
          }
          return acc;
        }, {});
      }
      if (liveList && liveList.length) {
        newLiveList = liverSearchResult.liveStatusList.reduce((acc, cur) => {
          if (cur.liveSecernId) {
            if (newLiveList && newLiveList[cur.liveSecernId] && newLiveList[cur.liveSecernId].liveEnteringLeavingDateList) {
              cur.liveEnteringLeavingDateList = newLiveList[cur.liveSecernId].liveEnteringLeavingDateList;
            }
            if (liveReservedList && liveReservedList[cur.liveSecernId] && liveReservedList[cur.liveSecernId].liveStartFrom) {
              cur.liveStartFrom = liveReservedList[cur.liveSecernId].liveStartFrom;
            }
            if (liveReservedList && liveReservedList[cur.liveSecernId] && liveReservedList[cur.liveSecernId].liveStartTo) {
              cur.liveStartTo = liveReservedList[cur.liveSecernId].liveStartTo;
            }
            if (liveReservedList && liveReservedList[cur.liveSecernId] && liveReservedList[cur.liveSecernId].liveName) {
              cur.liveName = liveReservedList[cur.liveSecernId].liveName;
            }
            if (liveReservedList && liveReservedList[cur.liveSecernId] && liveReservedList[cur.liveSecernId].organizerUserSecernId) {
              cur.organizerUserSecernId = liveReservedList[cur.liveSecernId].organizerUserSecernId;
            }
            if (userOrList && userOrList[cur.organizerUserSecernId] && userOrList[cur.organizerUserSecernId].userName) {
              cur.userName = userOrList[cur.organizerUserSecernId].userName;
            }
            acc.push(cur);
          }
          return acc;
        }, []);
        liveRecordNum = liverSearchResult.recordNum || 0;
        if (newLiveList && newLiveList.length) {
          liveUserObj = newLiveList.reduce((acc, cur) => {
            if (cur.liveSecernId) {
              acc.bySecernId[cur.liveSecernId] = cur;
              const liveEnteringLeavingDateListTemp = cur.liveEnteringLeavingDateList;
              const liveStartFrom = moment(cur.liveStartFrom);
              const liveStartTo = moment(cur.liveStartTo);
              if (liveEnteringLeavingDateListTemp) {
                const arrayPercent = createArrayDurationForChart(liveStartFrom, liveStartTo, liveEnteringLeavingDateListTemp);
                acc.bySecernId[cur.liveSecernId].arrayDataSetsForChart = arrayPercent;
              }
              acc.allSecernIds.push(cur.liveSecernId);
              return acc;
            }
          }, {
            bySecernId: {},
            allSecernIds: [],
          });
        }
      }
      return {
        ...state,
        liveList: newLiveList,
        liveUserObj,
        liveRecordNum,
      };
    }
    // #7129 START
    case ParticipantActionTypes.RESET_PARTICIPANT_DETAIL: {
      return {
        ...state,
        userList: [],
        liveList: [],
        liveUserObj: {},
      };
    }
    // #7129 END
    default: {
      return {
        ...state,
      };
    }
  }
}
